import React from "react";
import { Space, Table, Tag } from "antd";
import { saveAs } from "file-saver";
import { useDispatch, useSelector } from "react-redux";
import SearchInput from "../../../components/utils/SearchInput";
import {
  dateFormatterUI6,
  stringSorter,
} from "../../../utils/helpers/dataHelper";
import { deleteAttachedDocument } from "../../../actions/document.action";
import { Loading } from "../../../utils/helpers/constants";
import RoundLoader from "../../../components/loader/RoundLoader";
import { replaceString } from "../../../utils/helpers/dataHelper";

const DocumentTable = ({ list, handleSearch, handleCreate }) => {
  const dispatch = useDispatch();

  const {
    document: { attachDocumentLoading },
  } = useSelector(({ documentReducer }) => ({ document: documentReducer }));

  const deleteDocument = (item) => {
    if (item !== null) {
      dispatch(deleteAttachedDocument(item));
    }
  };

  const viewDocument = (item) => {
    if (item["secureImageUrl"] !== null) {
      window.open(item["secureImageUrl"], "_blank");
    }
  };

  const downloadDocument = (item) => {
    if (item["secureImageUrl"] !== null) {
      saveAs(item["secureImageUrl"], "file.jpg");
    }
  };

  const columns = [
    {
      title: "Document Type",
      dataIndex: "attachedDocumentType",
      render: (attachedDocumentType) => (
        <span>{replaceString(attachedDocumentType)}</span>
      ),
    },
    {
      title: "Created Date",
      dataIndex: "dateCreated",
      key: "dateCreated",
      render: (dateCreated) => <span>{dateFormatterUI6(dateCreated)}</span>,
      sorter: (a, b) => stringSorter(a.dateCreated, b.dateCreated),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Tag
            color={"red"}
            className="cursor-pointer"
            onClick={() => deleteDocument(record)}
          >
            Delete
          </Tag>
          <Tag
            color={"blue"}
            className="cursor-pointer"
            onClick={() => viewDocument(record)}
          >
            View
          </Tag>

          <Tag
            color={"green"}
            className="cursor-pointer"
            onClick={() => downloadDocument(record)}
          >
            Download
          </Tag>
        </Space>
      ),
    },
  ];

  const loadState = attachDocumentLoading === Loading.FETCHING;

  return (
    <div>
      <div className="flex justify-between items-center py-4 bg-white dark:bg-gray-800">
        <div>
          <button
            className="bg-green-800 text-white rounded-md p-2 px-4"
            onClick={() => handleCreate()}
          >
            add
          </button>
        </div>
        <SearchInput handleSearch={(value) => handleSearch(value)} />
      </div>
      {loadState ? (
        <RoundLoader />
      ) : (
        <>
          <Table
            columns={columns}
            // pagination={{}}
            dataSource={list}
            scroll={{
              x: 500,
            }}
            sticky
          />
        </>
      )}
    </div>
  );
};

export default DocumentTable;
